import { Injectable, inject } from '@angular/core';
import type { AffordabilityManagementResponse, AffordabilityManagementUpdateRequest } from '@lenderhub/models';
import { LenderHubDataService } from '@shared/services/lenderhub-data.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AffordabilityManagementService {
  private readonly lenderHubDataService = inject(LenderHubDataService);

  public getTables(lendingTypeCode: string): Observable<AffordabilityManagementResponse[]> {
    return this.lenderHubDataService.get<AffordabilityManagementResponse[]>(`AffordabilityManagement/${lendingTypeCode}`);
  }

  public updateTables(lendingTypeCode: string, updateRequest: AffordabilityManagementUpdateRequest): Observable<void> {
    return this.lenderHubDataService.patch(`AffordabilityManagement/${lendingTypeCode}`, updateRequest);
  }

  public updateScheduledDateTime(lendingTypeCode: string, date: Date): Observable<void> {
    return this.lenderHubDataService.put(`AffordabilityManagement/${lendingTypeCode}/schedule`, date);
  }

  public discardScheduledChanges(lendingTypeCode: string): Observable<void> {
    return this.lenderHubDataService.delete(`AffordabilityManagement/${lendingTypeCode}/schedule`);
  }
}
